import React from 'react';
import cn from 'classnames';
import Heading from '@wix/da-a11y/pkg/components/headings/Heading';
import GhostButton from '@wix/da-ds/pkg/Buttons/GhostButton';
import { useDispatch } from 'react-redux';
import { feedbackPageReload } from '../redux/actions/app';
import { useTranslation } from 'react-i18next';

import s from './GenericError.scss';

export interface Props {}

const GenericError: React.FC<Props> = () => {
  const { t } = useTranslation('nc');
  const dispatch = useDispatch();
  const doReload = () => {
    dispatch(feedbackPageReload({}));
  };

  return (
    <div className={cn(s['root'])}>
      <Heading className={s['header']}>{t('nc:generic.error.header')}</Heading>
      <p>{t('nc:generic.error.text')}</p>
      <GhostButton size={'medium'} variant={'main'} onClick={doReload}>
        {t('nc:generic.error.btn.reload')}
      </GhostButton>
    </div>
  );
};
GenericError.displayName = 'GenericError';

export default GenericError;
